/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrototypeFirmwareOnAzure } from './PrototypeFirmwareOnAzure';
import {
    PrototypeFirmwareOnAzureFromJSON,
    PrototypeFirmwareOnAzureFromJSONTyped,
    PrototypeFirmwareOnAzureToJSON,
    PrototypeFirmwareOnAzureToJSONTyped,
} from './PrototypeFirmwareOnAzure';

/**
 * 
 * @export
 * @interface PrototyperUserInfo
 */
export interface PrototyperUserInfo {
    /**
     * 
     * @type {string}
     * @memberof PrototyperUserInfo
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof PrototyperUserInfo
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof PrototyperUserInfo
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof PrototyperUserInfo
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof PrototyperUserInfo
     */
    org_code: string;
    /**
     * 
     * @type {Array<PrototypeFirmwareOnAzure>}
     * @memberof PrototyperUserInfo
     */
    assigned_firmwares: Array<PrototypeFirmwareOnAzure>;
}

/**
 * Check if a given object implements the PrototyperUserInfo interface.
 */
export function instanceOfPrototyperUserInfo(value: object): value is PrototyperUserInfo {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('assigned_firmwares' in value) || value['assigned_firmwares'] === undefined) return false;
    return true;
}

export function PrototyperUserInfoFromJSON(json: any): PrototyperUserInfo {
    return PrototyperUserInfoFromJSONTyped(json, false);
}

export function PrototyperUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrototyperUserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'phone_number': json['phone_number'],
        'org_code': json['org_code'],
        'assigned_firmwares': ((json['assigned_firmwares'] as Array<any>).map(PrototypeFirmwareOnAzureFromJSON)),
    };
}

export function PrototyperUserInfoToJSON(json: any): PrototyperUserInfo {
    return PrototyperUserInfoToJSONTyped(json, false);
}

export function PrototyperUserInfoToJSONTyped(value?: PrototyperUserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'phone_number': value['phone_number'],
        'org_code': value['org_code'],
        'assigned_firmwares': ((value['assigned_firmwares'] as Array<any>).map(PrototypeFirmwareOnAzureToJSON)),
    };
}

